// extracted by css-extract-rspack-plugin
export default {"advMarkContainer":"adv-mark-container--rB5pzIrX1X4VJHh8","advMark":"adv-mark--qpjNbb7cqBYY2VYo"};